export const AZURE_REDIRECT_URI: string = process.env.AZURE_REDIRECT_URI || ''
export const AZURE_AUTHORITY: string = process.env.AZURE_AUTHORITY || ''
export const AZURE_CLIENT_ID: string = process.env.AZURE_CLIENT_ID || ''
